/* eslint-disable react/prop-types */
import Table from 'components/Table';
import React from 'react';
import currencyFormatter from 'utils/currencyFormatter';
import { getModelPermission } from 'utils/permission';

export const NominaOtroPagoPermission = {
  permissionModel: 'nominaplazaotropago',
  catalogsModels: [],
  tabsModels: [],
};

const NominasOtrosPagos = ({ data }) => {
  const getPermission = getModelPermission(
    NominaOtroPagoPermission.permissionModel,
    NominaOtroPagoPermission.catalogsModels,
    NominaOtroPagoPermission.tabsModels,
    false,
  );

  const totalImporte = data.reduce((suma, actual) => suma + (actual?.importe || 0), 0);

  const columns = [
    {
      titleText: 'Otro Pago',
      dataIndex: 'concepto',
      key: 'concepto',
      width: 200,
    },
    {
      titleText: 'Importe',
      dataIndex: 'importe',
      key: 'importe',
      width: 200,
      align: 'right',
      render: (val) => currencyFormatter(val),
    },
  ];

  const summaryCells = [
    {
      label: 'Total',
      value: totalImporte,
      valueAlign: 'right',
      render: (val) => currencyFormatter(val || 0),
    },
  ];

  return (
    <Table
      cols={columns}
      allowExportPDF={false}
      data={data}
      summaryCells={summaryCells}
      permission={getPermission}
    />
  );
};

export default NominasOtrosPagos;
